const SafeToLowerCase = (string) => {
    return string && typeof(string) === 'string' && string.length > 0 ? string.toLowerCase() : ' '
}

const sortAlphabetically = (arr, value) => {
    // return arr.sort((a, b) => a[value].localeCompare(b[value]));

    return arr.sort((a, b) => {
        return (a[value] === "") - (b[value] === "") || +(SafeToLowerCase(a[value]) > SafeToLowerCase(b[value]))||-(SafeToLowerCase(a[value]) < SafeToLowerCase(b[value]));
    });
};

export default sortAlphabetically;